import AppData from '@/mixins/appdata'
import Translatable from '@/mixins/translatable'
import PaymentTypeEnum from '@/api/Enums/PaymentTypeEnum'
import {clone, sortBy} from '@/lib/helper/helper'
import {isObject} from '@/lib/data/Validations/utils/Utils.js'

export default {
  data() {
    return {}
  },
  components: {},
  mixins    : [AppData, Translatable],
  directives: {},
  watch     : {},
  methods   : {
    getOrderPaymentType(order) {
      return order?.Payment ? this.getPaymentTypeByCode(order.Payment) : null
    },

    getPaymentTypeByCode(code) {
      for (const payment in this.paymentTypes) {
        if (this.paymentTypes.hasOwnProperty(payment) && this.paymentTypes[payment].code === code) {
          const val = this.paymentTypes[payment]
          val.icon = this.paymentTypes[payment].code === PaymentTypeEnum.CASH ? this.appCurrency.Icon : val.icon
          if (PaymentTypeEnum.isIris(val.code)) val.name = val.code.toUpperCase().replaceAll('_', ' ')

          return val
        }
      }
      return null
    },

    getPaymentTypeLangByCode(code) {
      return this.paymentTypesLang?.find(p => p.Code === code) || this.paymentTypesExtraLang?.find(p => p.Code === code) || this.paymentTypesAllLang?.find(p => p.Code === code) || {}
    }
  },
  computed: {
    userPaymentTypes() {
      const active = this.posUser?.Settings?.AllUsers?.ActivePaymentTypes?.Active ?? false
      const items = this.posUser?.Settings?.AllUsers?.ActivePaymentTypes?.Items || []

      return {
        Active: active && items.length > 0,
        Items : items
      }
    },

    paymentTypes() {
      const paymentTypes = clone(this.appConfig?.PAYMENT_TYPES || [])
      return sortBy(paymentTypes, 'priority', 'asc')
    },

    paymentTypesActive() {
      return this.paymentTypes.filter(paymentType => paymentType.active)
    },

    paymentTypesForDeliveryStaff() {
      return this.paymentTypesForPos.filter(paymentType => PaymentTypeEnum.isMethodDeliveryStaffOrderPayable(paymentType.code))
      //return this.paymentTypesForPos.filter(paymentType => PaymentTypeEnum.isMethodDeliveryStaffOrderPayable(paymentType.code) && paymentType.code !== this.selectedTransaction?.PaymentType)
    },

    paymentTypesForPos() {
      return this.paymentTypesActive
        .filter(paymentType => !!paymentType.pos)
        .filter(paymentType => this.userPaymentTypes.Active ? this.userPaymentTypes.Items.includes(paymentType.code) : true)
    },

    paymentTypesForTables() {
      return this.paymentTypesActive
        .filter(paymentType => !!paymentType.table)
        .filter(paymentType => this.userPaymentTypes.Active ? this.userPaymentTypes.Items.includes(paymentType.code) : true)
    },

    paymentTypesForOnline() {
      return this.paymentTypesActive.filter(paymentType => !!paymentType.site)
    },

    paymentTypesFiltersList() {
      return this.paymentTypes.map(o => {
        return {
          Code  : o.code,
          Title : this.getTranslatedField(o, 'Name', 'lang'),
          Avatar: {
            Icon : o.icon,
            Color: o.color2
          }
        }
      })
    },

    paymentTypesLang() {
      return [this.$t('Order.PaymentMethod.Cash'), this.$t('Order.PaymentMethod.Card')].map(o => {
        o.Avatar = {
          Icon : o.Icon,
          Color: o.Color
        }
        return o
      })
    },

    paymentTypesExtraLang() {
      return [this.$t('Order.PaymentMethod.OnCredit'), this.$t('Order.PaymentMethod.Iris'), this.$t('Order.PaymentMethod.WebBanking'), this.$t('Order.PaymentMethod.Check')].map(o => {
        o.Avatar = {
          Icon : o.Icon || '',
          Image: o.Image || '',
          Color: o.Color || ''
        }
        return o
      })
    },

    paymentTypesAllLang() {
      return Object.values(this.$t('Order.PaymentMethod')).filter(o => isObject(o)).map(o => {
        o.Avatar = {
          Icon : o.Icon || '',
          Image: o.Image || '',
          Color: o.Color || ''
        }
        return o
      })
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  }
}
